import React from 'react'
import { connect } from 'react-redux';

import {
  getLoanApplication,
  getErrorMessage
} from '../../../reducers'

import AddressWithMap from 'components/AddressWithMap'
import LoanAmount from 'components/LoanAmount'
import ApplicantsForm from 'components/ApplicantsForm'
import ContinueButton from 'components/ContinueButton'

import Target from './Target'

import {
  loanApplicationUpdateStart
} from '../../../actions'

class ConfirmApproval extends React.Component {
  state = {
    locationAddress: null,
    locationSuburb: null,
    locationPostcode: null,
    locationState: null,
    displayFullForm: false,
    applicant: null,
    userName: '',
    userMobile: '',
    userEmail: '',
    secondaryValid: false,
    loanAmount: this.props.loanAmount,
    spendAmount: this.props.spendAmount,
    rentAmount: this.props.rentAmount,
    loanAmountValid: true,
    postcodeValid: false,
    target: this.props.target,
  }

  addressChanged = (addressData) => {
    const {
      locationAddress,
      locationSuburb,
      locationPostcode,
      locationState,
      coords,
    } = addressData

    this.setState({
      locationAddress,
      locationSuburb,
      locationPostcode,
      locationState,
      coords,
      displayFullForm: true,
    })
  }

  postcodeValidationSuccess = () => {
    this.setState({ postcodeValid: true })
  }

  postcodeValidationFailure = () => {
    this.setState({ postcodeValid: false })
  }

  onLoanAmountChange = (data) => {
    this.setState({
      ...data
    })
  }

  onApplicantChange = (params) => {
    this.setState(params)
  }

  onContinueClick = () => {
    this.props.loanApplicationUpdateStart({
      id: this.props.loanApplicationId,
      params: {
        application_form_conditional_approved: {
          ...this.state,
        },
      },
    })
  }

  continueEnabled = () => {
    const {
      postcodeValid,
      loanAmountValid,
      applicant,
      secondaryValid,
    } = this.state

    const {
      hasSecondaryApplicant,
    } = this.props;

    return (
      postcodeValid &&
      loanAmountValid &&
      (hasSecondaryApplicant || applicant == 'primary' ? true : secondaryValid)
    )
  }

  render() {
    let {
      displayFullForm,
      target,
      userName,
      userMobile,
      userEmail,
    } = this.state

    const {
      loanAmount,
      spendAmount,
      rentAmount,
      hasSecondaryApplicant,
    } = this.props

    return(
      <div>
        <h3>Confirm Approval</h3>
        <Target
          value={ target }
          onChange={ (value) => this.setState({target: value}) }
        />
        <div className='card card-single'>
          <div className='card-body'>
            <AddressWithMap
              label='Please enter your address'
              onChange={ this.addressChanged }
              validateServicedPostcode={ true }
              postcodeValidationSuccess={ this.postcodeValidationSuccess }
              postcodeValidationFailure={ this.postcodeValidationFailure }
            />
            {
              (displayFullForm) && (
                <LoanAmount
                  loanPurpose={ 'purchase' }
                  target={target}
                  needsRentAmount={ target == 'investment' }
                  hasFoundHome={ true }
                  loanAmount={ loanAmount }
                  spendAmount={ spendAmount }
                  rentAmount={ rentAmount }
                  onChange={ this.onLoanAmountChange }
                 />
              )
            }
          </div>
        </div>
        {
          (displayFullForm && !hasSecondaryApplicant) && (
            <ApplicantsForm
              onSelectionChange={ (value) => this.setState({ applicant: value }) }
              applicant={ this.state.applicant }
              onApplicantChange={ this.onApplicantChange }
              userName={ userName }
              userMobile={ userMobile }
              userEmail={ userEmail }
              errors={ this.props.errors }
            />
          )
        }
        <div className="col text-right" >
          <div className="pull-right">
            <ContinueButton
              onClick={ this.onContinueClick }
              enabled={ this.continueEnabled() }
            />
          </div>
          <div className="clearfix" />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  errors: getErrorMessage(state),
  target: getLoanApplication(state).target,
  loanAmount: getLoanApplication(state).loanAmount,
  spendAmount: getLoanApplication(state).spendAmount,
  rentAmount: getLoanApplication(state).rentAmount,
  hasSecondaryApplicant: getLoanApplication(state).hasSecondaryApplicant,
  loanApplicationId: getLoanApplication(state).id,
})

export default connect(mapStateToProps, {
 loanApplicationUpdateStart,
})(ConfirmApproval)
